import React, { Component } from 'react';
import { inject, observer } from 'mobx-react/index';

@inject('store')
@observer
export class PositionStatusPanel extends Component {
    render() {
        const liveTrades = this.props.store.botStore.positions;
        let current_value = 0;
        let max_exposure = 0;
        let pl = 0;
        let reserve = 0;

        liveTrades
            .filter(o => o.active && o.status)
            .forEach(t => {
                max_exposure += t.max_cost || 0;
                current_value += t.curr_value || 0;
                pl += t.pl || 0;
                reserve += t.used_reserve || 0;
            });

        const totalPercent = (((current_value - max_exposure) / max_exposure) * 100 || 0).toFixed(
            2
        );

        return (
            <div className={'position-status'}>
                <b>Summary:</b>&nbsp;&nbsp;&nbsp;Invested: {max_exposure.toFixed(8)}
                &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp; Current Value: {current_value.toFixed(8)}{' '}
                <span className={totalPercent >= 0 ? 'success' : 'error'}>({totalPercent}%)</span>
                &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp; P/L{' '}
                <span className={pl >= 0 ? 'success' : 'error'}>{pl.toFixed(8)}</span>
                &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp; Reserve {reserve.toFixed(8)}/
                {(this.props.store.botStore.currentConfiguration.reserve_allocation || 0).toFixed(
                    8
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/PositionsView/PositionStatusPanel.js